export default __webpack_public_path__ + "static/media/profile-img-test.f1956aca.jpg";